import React, {useContext} from 'react';
import styled, {css, DefaultTheme, ThemeProvider} from 'styled-components';

import {ContentWrittenBy} from '@components/molecules/content/writtenby';

import {getThemes} from '~/src/utilities/helpers/brand';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {SiteArea} from '~/src/utilities/constants/navigation';

import variables from '~/src/css/global.module.scss';
import {Author} from '~/src/types/meta';

export interface AuthorsProps {
    authors: Author[];
    meta?: {
        published?: string;
        updated?: string;
    };
}

const sassVariableHelper = (variable: string) => variables[variable];

const Migrated = styled(({migration, ...props}) => <ContentWrittenBy {...props} />)`
    border-top: 1px solid ${sassVariableHelper('mainBackgroundColor')};
    font-size: 16px;

    ${({migration}) => {
        if (migration.isLifestyle) {
            return css`
                color: ${sassVariableHelper('colorWhite')};
                padding: 36px 0 24px;
            `;
        }

        return css`
            border-bottom: 1px solid ${sassVariableHelper('mainBackgroundColor')};
            font-weight: ${sassVariableHelper('fontWeightHeavy')};
            padding: 14px 0;
        `;
    }}
`;

const getImageSrc = ({userImage}: Author) => {
    return (
        userImage &&
        userImage.variants &&
        Object.values(userImage.variants)
            .map(({src}) => src)
            .pop()
    );
};

const Themes = getThemes();
const PassThrough = (theme: DefaultTheme) => theme;

const Authors = ({authors, meta}: AuthorsProps) => {
    const {siteArea} = useContext(SettingsContext);
    const isLifestyle = siteArea === SiteArea.LIFESTYLE;

    const mappedProps = {
        authors: authors.map((author) => ({
            name: author.name,
            image: getImageSrc(author),
            info: author.info
        })),
        direction: isLifestyle ? 'block' : 'inline'
    };

    return (
        <ThemeProvider theme={isLifestyle ? Themes.LifestyleAlternative : PassThrough}>
            <Migrated {...mappedProps} migration={{isLifestyle}} />
        </ThemeProvider>
    );
};

export default Authors;
